export enum ECalendarTlCode {
  Previous,
  Week,
  Day,
  Month,
  NextDay,
  Resource,
  Today,
}
